import script from "./TagCreateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TagCreateDialog.vue?vue&type=script&setup=true&lang=js"

import "./TagCreateDialog.vue?vue&type=style&index=0&id=4a78103d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a78103d"]])

export default __exports__